export default {
  // App
  appName: "Flautreach",
  appTagline: "AI-powered social media scraping & filtering",
  
  // Auth
  signIn: "Sign In",
  signUp: "Sign Up",
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  signInBtn: "Sign In",
  createAccount: "Create Account",
  forgotPassword: "Forgot password?",
  resetPassword: "Reset Password",
  resetDesc: "Enter your email and we'll send a reset link.",
  sendResetLink: "Send Reset Link",
  cancel: "Cancel",
  passwordsDontMatch: "Passwords don't match",
  passwordTooShort: "Password must be ≥ 8 characters",
  accountCreated: "Account created! Check your email to verify.",
  resetSent: "Reset link sent if that email exists!",
  emailPlaceholder: "you@company.com",
  passwordPlaceholder: "••••••••",

  // Navigation
  myTasks: "My Tasks",
  newTask: "New Task",
  balance: "Balance",
  visualization: "Visualization",
  support: "Support",
  signOut: "Sign Out",

  // Tasks
  tasksList: "Tasks",
  newTaskTitle: "New Task",
  tasksDesc: "Manage your scraping and filtering tasks",
  noTasks: "No tasks yet",
  noTasksDesc: "Create your first task to start collecting data from social media.",
  createFirstTask: "Create Your First Task",
  
  // Task types
  taskType: "Task Type",
  scraping: "Scraping",
  filtering: "Filtering",
  scrapingFiltering: "Scraping + Filtering",
  scrapingDesc: "Collect info from social media",
  filteringDesc: "Filter collected info",
  scrapingFilteringDesc: "Collect & Filter",
  
  // Task form
  taskName: "Task Name",
  
  keywords: "Keywords / Search Query",
  keywordsPlaceholder: "e.g., web designer, UX designer, graphic designer",
  keywordsHint: "Separate keywords with commas",
  platforms: "Platforms",
  selectPlatforms: "Select platforms to scrape",
  filters: "Filters",
  followersMin: "Min followers",
  followersMax: "Max followers",
  postsMin: "Min posts",
  postsMax: "Max posts",
  bioMinLength: "Min bio length",
  privateAccounts: "Include private accounts",
  hasLink: "Must have link in bio",
  keywordsInName: "Keywords in name",
  keywordsInBio: "Keywords in bio",
  keywordsInLink: "Keywords in link",
  language: "Bio Language",
  languageAll: "All languages",
  languageEn: "English",
  languagePl: "Polish",
  languageDe: "German",
  createTask: "Create Task",
  creating: "Creating...",
  taskCreated: "Task created successfully!",
  
  // Task statuses
  not_started: "Not started",
  running: "Running",
  paused: "Paused",
  completed: "Completed",
  start: "Start",
  stop: "Stop",
  delete: "Delete",
  deleteConfirm: "Delete this task?",
  taskStarted: "Task started",
  taskStopped: "Task stopped",
  taskDeleted: "Task deleted",
  results: "results",

  // Balance
  balanceTitle: "Balance & Credits",
  scrapingBalance: "Scraping Credits",
  aiBalance: "AI Analysis Credits",
  topUp: "Top Up",
  choosePlan: "Choose Plan",
  customAmount: "Custom Amount",
  
  // Tariffs
  plansTitle: "Choose Your Plan",
  planBasic: "Basic",
  planPro: "Pro",
  planEnterprise: "Enterprise",
  planBasicPrice: "€20",
  planProPrice: "€50",
  planEnterprisePrice: "€100",
  planBasicScraping: "1,000 scraping credits",
  planBasicAI: "100 AI credits",
  planProScraping: "5,000 scraping credits",
  planProAI: "500 AI credits",
  planEnterpriseScraping: "20,000 scraping credits",
  planEnterpriseAI: "2,000 AI credits",
  customPlan: "Custom Top-Up",
  customPlanDesc: "Choose exactly how many credits you need",
  scrapingCredits: "Scraping credits",
  aiCredits: "AI analysis credits",
  totalPrice: "Total: €{price}",
  purchase: "Purchase",
  purchaseSuccess: "Balance topped up successfully!",
  
  // Visualization
  visualizationTitle: "Visualization",
  selectTask: "Select Task",
  visualizationType: "Visualization Type",
  standardView: "Standard View",
  aiView: "AI-Powered View",
  standardViewDesc: "Show profiles with basic info",
  aiViewDesc: "Analyze profiles with AI using custom prompt",
  profilesCount: "Number of profiles",
  aiPrompt: "AI Prompt",
  aiPromptPlaceholder: "e.g., Rate this profile for [[FULLNAME]]: [[BIO]]. Check link: [[LINK]]",
  aiPromptHint: "Use [[FULLNAME]], [[BIO]], [[LINK]] as placeholders",
  startVisualization: "Start Visualization",
  visualizing: "Processing...",
  profilesFound: "profiles found",
  copy: "Copy",
  save: "Save",
  copied: "Copied!",
  saved: "Saved!",

  
  
  // Common
  verifyBanner: "Please verify your email",
  verifyBanner2: "to unlock all features.",
  resendVerify: "Resend verification email",
  verifySent: "Verification email sent! Check your inbox.",
  langSwitch: "Language",
  planLabel: "Plan:",
  save: "Save",
  cancel: "Cancel",
  close: "Close",
  
  // Errors
  unauthorized: "Unauthorized",
  loginFailed: "Login failed",
  regFailed: "Registration failed",
  fetchFailed: "Failed to fetch",
  createFailed: "Failed to create task",
  deleteFailed: "Failed to delete task",
  toggleFailed: "Failed to toggle task",
  topUpFailed: "Failed to top up balance",
  supportFailed: "Failed to send message",

  balanceAndCredits: "Manage your credits",
visualizeAndAnalyze: "View and analyze your results",
scrapingCreditsLabel: "🔄 Scraping",
aiCreditsLabel: "🤖 AI",

clearAll: "Clear All",
clearAllConfirm: "Are you sure you want to clear all fields?",

// en.js
selectTaskToFilter: "Select Task to Filter",
chooseExistingTask: "Choose existing scraping task to apply filters",
selectTask: "-- Select a task --",
template: "Template",
aiFiltering: "AI Filtering",
enable: "Enable",
whatResult: "What result do you want to achieve?",
describeFiltering: "Describe what kind of filtering you need...",
generateAIPrompt: "Generate AI Prompt",
availablePlaceholders: "Available Placeholders (click to insert)",
testPrompt: "Test Prompt on Sample Profiles",
testPromptDesc: "Opens visualization with 5 random profiles using this prompt",
matchCondition: "Match Condition",
matchConditionDesc: "Define which word indicates successful filter match",
wordToMatch: "Word to match",
wordToMatchPlaceholder: "e.g., approved, valid, success",
searchScope: "Search scope",
entireText: "Entire Text",
firstLineOnly: "First Line Only",
creditsRequired: "Credits Required",
activeFiltersCredits: "Active filters × 0.3",
plusAI: "+ 1 (AI) credits",

// en.js
platform: "Platform",
step1ChooseNetwork: "Step 1: Choose social network",
step2WhatToFind: "Step 2: What to find on {platform}?",
scrapeAuthorPages: "Scrape Author Pages",
scrapeAuthorPagesDesc: "Visit author profiles of found posts to extract bio, followers & contact info.",
on: "ON",
off: "OFF",
whoToFind: "Who do you want to find?",
whoToFindPlaceholder: "Describe who or what you're looking for...",
editable: "editable",
targetInserted: "target inserted",
fillTargetAbove: "fill target above",
generateWithAI: "Generate with AI",
generating: "Generating...",
aiThinking: "AI is thinking...",
searchQueries: "Search Queries",
oneQueryPerLine: "One query per line.",
addedAutomatically: "added automatically.",
clickToCheckGoogle: "Click 🔗 to check in Google.",
enterSearchQueries: "Enter search queries...\none per line",
google: "Google",
activeQuery: "active query",
activeQueries: "active queries",
advancedSettings: "Advanced Settings",
searchLanguage: "Search Language",
popular: "Popular",
allLanguages: "All Languages",
scrapingPeriod: "Scraping Period",
anyTimeSelected: "Any time selected",
periodsSelected: "period(s) selected",
maxPagesPerQuery: "Max Pages per Query",
schedule: "Schedule",
oneTime: "One-time",
runsOnce: "Runs once",
repeat: "Repeat",
autoRuns: "Auto-runs",
daily: "Daily",
weekly: "Weekly",
monthly: "Monthly",
every: "Every...",
queries: "queries",
pages: "pages",
periods: "periods",
filtering: "Filtering",
authorPages: "author pages",
clickOutsideToClose: "Click outside or Esc to close",

// en.js
additionalFilters: "Additional Filters",

// en.js
edit: "Edit",
duplicate: "Duplicate",
createFilteringTask: "Create Filtering Task",
moreActions: "More actions",
authorPagesLabel: "Author Pages",
extraConfig: "Extra Config",
additionalSettings: "Additional Settings",
scrapeAuthorPages: "Scrape Author Pages",
enabled: "Enabled",
disabled: "Disabled",
authorPagesEnabledDesc: "If we scrape link for post/reel, we will scrape the page of the author",
authorPagesDisabledDesc: "Author pages will not be scraped",
scrapingTokensLabel: "Scraping Tokens",
aiTokensLabel: "AI Tokens",
jobsBreakdown: "Jobs Breakdown",
googleJobs: "Google Jobs",
scrapedLinks: "Scraped Links",
found: "found",
jobsCompleted: "jobs completed",
failed: "failed",
completed: "Completed",
ofTotal: "of total",
searchConfig: "Search Config",
maxPages: "Max",
created: "Created",
started: "Started",
finished: "Finished",
notAuthenticated: "Not authenticated",
failedToLoadTasks: "Failed to load tasks",
retry: "Retry",
active: "active",
total: "total",
complete: "complete",
running: "running",
start: "Start",
stop: "Stop",
delete: "Delete",
deleteConfirm: "Delete this task?",
visualization: "Visualization",
newTask: "New Task",

// Статусы
not_started: "Not started",
running: "Running",
paused: "Paused",
completed: "Completed",
done: "Done",
failed: "Failed",

// en.js
failedToLoadImage: "Failed to load image",
loadingImage: "Loading image...",
backToTasks: "Back to Tasks",
visualization: "Visualization",
browseResults: "Browse scraped results one by one",
configuration: "Configuration",
selectTaskAndOptions: "Select task and visualization options",
task: "Task",
selectTask: "-- Select task --",
done: "done",
type: "Type",
standard: "Standard",
ai: "AI",
mode: "Mode",
all: "All",
random: "Random",
randomCount: "Random Count",
aiPromptLabel: "AI Prompt",
aiPromptPlaceholder: "Describe what you want AI to analyze...",
howItWorks: "How it works",
howItWorksDesc: "Write a prompt for AI. Click variables below to insert them — they will be replaced with actual data from each result.",
setFilterKeywordDesc: "Set a Filter Keyword to check AI response and see PASSED or FAILED for each result.",
availableVariables: "Available Variables (click to insert)",
filterCheckKeyword: "Filter: Check AI response for keyword",
filterCheckDesc: "If keyword found → PASSED, if not → FAILED",
keywordPlaceholder: "Keyword to find (e.g. yes, no, approved)",
firstLineOnly: "First line only",
fullText: "Full text",
subtype: "Subtype",
startVisualization: "Start Visualization",
loading: "Loading",
prev: "Prev",
result: "Result",
of: "of",
loaded: "Loaded",
allLoaded: "all loaded",
end: "End",
next: "Next",
reachedEnd: "You've reached the end! All",
resultsLoaded: "results loaded",
loadingNextBatch: "Loading next batch",
status: "Status",
copyRaw: "Copy Raw",
aiAnalysis: "AI Analysis",
passed: "PASSED",
failed: "failed",
cost: "Cost",
remaining: "Remaining",
waitingForAI: "Waiting for AI response",
retry: "Retry",
openProfile: "Open profile",
keyword: "Keyword",
viaPost: "Via post",
position: "Position",
page: "Page",
period: "Period",
noResultsFound: "No results found",
noResultsDesc: "This task has no scraped results yet.",
arrowKeysHint: "Use ← → arrow keys to navigate · Images preload in background",

// en.js



// en.js
posts: "Posts",
pages: "Pages",
findInstagramPosts: "Find Instagram posts & reels",
findInstagramProfiles: "Find Instagram profiles & bios",
findFacebookPosts: "Find public Facebook posts",
findFacebookPages: "Find Facebook business pages & communities",
findLinkedInPosts: "Find professional LinkedIn posts",
anyTime: "Any Time",
pastYear: "Past Year",
pastMonth: "Past Month",
pastWeek: "Past Week",
past24h: "Past 24h",
pastHour: "Past Hour",




// Filter operators
// en.js
filterOperators: {
  equals: "Equals",
  contains: "Contains",
  not_contains: "Does not contain",
  contains_any_row: "Contains any row",
  not_contains_any_row: "Does not contain any row",
  is_not_empty: "Not empty",
  greater_than: "Greater than",
  less_than: "Less than",
  between: "Between",
  is_true: "Is true",
  is_false: "Is false",
},



// Filter builder
filterBuilder: "Filter Builder",
addRule: "Add Rule",
addRuleGroup: "Add Rule Group",
removeRule: "Remove rule",
noRules: "No rules added yet",
matchType: "Match type",
matchAll: "ALL (AND)",
matchAny: "ANY (OR)",
selectField: "Select field",
selectOperator: "Select operator",
enterValue: "Enter value",
minValue: "Min",
maxValue: "Max",
clearAllRules: "Clear all rules",
previewResults: "Preview results",
rulesPreview: "Rules preview",

// en.js
filterBuilder: "Filter Builder",
filterBuilderDesc: "Define conditions to filter results. Each row is one condition.",
addRule: "Add condition",
clearAllRules: "Clear all",
selectField: "Field",
selectOperator: "Operator",
enterValue: "Value",
noValueNeeded: "No value needed",
minValue: "Min",
maxValue: "Max",
allConditions: "ALL conditions",
anyCondition: "Any condition",
allConditionsDesc: "Result must match EVERY condition below",
anyConditionDesc: "Result must match AT LEAST ONE condition below",
singleRule: "One condition",
noRules: "No conditions",
rules: "conditions",


// en.js
taskName: "Task name",
createFilteringTask: "Create filtering task",
selectTaskFirst: "Select a task first",
saving: "Saving",

filtering: "Filtering",
filteringConfig: "Filtering Config",
aiFilteringEnabled: "AI filtering enabled",
aiFilteringDisabled: "AI filtering disabled",
passKeyword: "AI filter pass word",
checkFirstRowOnly: "Check first row only",
filterRules: "Filter Rules",
equals: "equals",
contains: "contains",
doesNotContain: "does not contain",
containsAny: "contains any",
containsAnyOf: "contains any of",
valuesCount: "values",
moreCount: "+{{count}} more",
excludesAll: "excludes all",
excludesAllOf: "excludes all of",
showAll: "show all",
showLess: "show less",
isNotEmpty: "is not empty",
greaterThan: "> {{val}}",
lessThan: "< {{val}}",
between: "{{min}} — {{max}}",
isTrue: "is true",
isFalse: "is false",
filteringResults: "Filtering Results",
totalRuns: "Total",
passedFilter: "Passed",
rejectedFilter: "Rejected",
failedFilter: "Failed",
doneFilter: "done",
runningFilter: "running",
pendingFilter: "pending",
ofTotal: "of total",
aiResults: "AI Results",
aiPassed: "passed",
aiRejected: "rejected",
recentRuns: "Recent Runs",
showAllRuns: "Show all runs",
noFilteringData: "No filtering data yet",


"forceStop": {
      "aitokens": {
        "title": "Task Stopped - No AI Tokens",
        "message": "Yo bro! You're out of AI tokens. Top up to keep going! 💰",
        "action": "Top Up AI Tokens",
        "details": "Task: {{taskId}} | Need: {{required}} | Have: {{available}}"
      },
      "scrapingtokens": {
        "title": "Task Stopped - No Scraping Tokens",
        "message": "Bro! Out of scraping tokens. Fix that wallet! 🚀",
        "action": "Top Up Scraping Tokens",
        "details": "Task: {{taskId}} | Need: {{required}} | Have: {{available}}"
      }
    },
"wallet": {
    "tokenTypes": {
      "ai": "AI Tokens",
      "scraping": "Scraping Tokens"
    }
  },

// en.js
noAITokensTitle: "Not enough AI tokens",
noAITokensMessage: "Bro, you ran out of AI tokens. Top up your balance to continue.",
noScrapingTokensTitle: "Not enough scraping tokens",
noScrapingTokensMessage: "Bro, you ran out of scraping tokens. Top up your balance to continue.",
noAITokens: "No AI tokens",
noScrapingTokens: "No scraping tokens",
topUp: "Top Up",


fromScratch: "From scratch",
fromScratchDesc: "Configure all parameters manually",
fromTemplate: "From template",
fromTemplateDesc: "Pick a preset and adjust it",
chooseTemplate: "Choose a template",
taskSelectionDesc: "Start from scratch or use a ready-made template",
continue: "Continue",



verifyInProgress: "Verifying your email...",
verifySuccess: "Email verified successfully!",
verifySuccessTitle: "Email Verified!",
verifyError: "Verification failed",
verifyErrorTitle: "Verification Failed",
verifyInvalidToken: "Invalid verification link",
goToLogin: "Go to Login",

resetPassword: "Reset Password",
resetPasswordDesc: "Enter your new password",
newPassword: "New Password",
newPasswordPlaceholder: "Enter new password",
confirmPassword: "Confirm Password",
confirmPasswordPlaceholder: "Confirm new password",
resetPasswordBtn: "Reset Password",
passwordResetSuccess: "Password Reset!",
passwordResetSuccessDesc: "Your password has been reset successfully. You can now login with your new password.",
passwordResetError: "Password reset failed",
invalidResetLink: "Invalid Reset Link",
invalidResetLinkDesc: "This password reset link is invalid or has expired.",

// en.js
verifyEmailToLogin: "Please verify your email before logging in. Check your inbox.",
checkInbox: "Check your inbox and click the verification link.",
resendVerificationBtn: "Resend verification email",
backToLogin: "Back to login",
enterEmailFirst: "Please enter your email first",









































defaultPrompts: {
  instagram_posts: 'Check instagram post with text "[[TEXT]]". \n\n Is it about cats and dogs? \n\n Write only "yes" or "no" on the first row, explain your decision on second.',
  instagram_pages: 'Analyze this Instagram page. Bio: "[[BIO]]". \n\n Is this a business account? \n\n Answer "yes" or "no" on first line, then explain.',
  facebook_posts: 'Check Facebook post: "[[TEXT]]". \n\n Is it promotional content?  \n\nAnswer only "yes" or "no" on first row, explain on second.',
  linkedin_posts: 'Analyze LinkedIn post: "[[TEXT]]".  \n\nIs it a job posting?  \n\nWrite "yes" or "no" on first line, then explain.',
  facebook_pages: 'Check this Facebook page. Description: "[[STATUS]]". \n\n Is it a company page? \n\n Answer "yes" or "no" on first row, explain on second.',
  
   instagram_reels: 'Analyze this Instagram Reel. Text: "[[TEXT]]". Video: [[VIDEO]]. \n\n Is this content about cooking? \n\n Write only "yes" or "no" on the first row, explain your decision on second.',
  default: 'Analyze this data. \n\n  Is it about jobs?  \n\nWrite "yes" or "no" on first line based on your analysis, then explain.',

  default_pass_word: 'yes'
},

 referralsPage: {
    loading: "Loading referral data...",
    headerTitle: "Referral Program",
    name: "Referrals",
    headerSubtitle: "Share your link and earn 30% on referral payments.",
    linkCardTitle: "Your Referral Link",
    linkCardDescription: "Share this link with others. Once they register, you'll earn a 30% commission on their payments.",
    referralId: "Referral ID",
    created: "Created",
    copy: "Copy",
    copied: "✓ Copied!",
    createButton: "🔗 Generate Referral Link",
    creating: "Creating...",
    totalReferrals: "Total Referrals",
    active: "active",
    totalEarned: "Total Earned",
    fromReferralsPayments: "From referral payments",
    totalPayments: "Total Payments",
    successfulPayments: "Successful payments",
    tableTitle: "Your Referrals",
    tableEmpty: "No referrals yet. Share your link to start earning!",
    userColumn: "User",
    registeredColumn: "Registered",
    paymentsColumn: "Payments",
    earnedColumn: "Total Earned",
    userLabel: "User",
    registeredLabel: "Registered",
    paymentsLabel: "Payments",
    earnedLabel: "Earned",
    previous: "← Previous",
    next: "Next →",
    pageOf: "Page {page} of {totalPages}",
    failedToLoad: "Failed to load referral data",
    failedToCreate: "Failed to create referral link",
    failedToDelete: "Failed to delete referral link",
    deleteConfirmation: "Delete this referral link?",
    errorDefault: "Failed to load data",
    dateLocale: "en-US",
    currency: "USD"
  },


  PageHeader: {
    scrapingLabel: '🔄 Scraping',
    aiLabel: '🤖 AI',
  },

  supportModal: {
      supportTitle: "Support",
      supportHelp: "You can contact support via email at support@flautreach.com or use this form.",
      supportPlaceholder: "Describe your issue or question...",
      supportResponse: "We typically respond within 24 hours.",
      sendMessage: "Send Message",
      supportEnterMsg: "Please enter a message",
      supportSent: "Support request sent! We'll respond to your EMAIL within 24h.",

  },

  sidebar: {
     myTasks: "My Tasks",
    newTask: "New Task",
    balance: "Balance",
    visualization: "Visualization",
    support: "Support",
    referrals: 'Referrals',
    signOut: "Sign Out",
  },

   balancePage: {
    headerTitle: "Balance & Tokens",
    headerSubtitle: "Top up balance and convert tokens",
    balanceLabel: "💵 Balance",
    scrapingTokensLabel: "🔄 Scraping Tokens",
    aiTokensLabel: "🤖 AI Tokens",
    usdToTokensRate: "$1 = {rate} tokens",
    aiTokensRate: "${price} = 1,000,000 tokens",
    aiTokensFormula: "Total AI tokens = input_tokens + 2 × output_tokens",
    aiTokensFormulaDesc: "AI token usage is calculated as the sum of input tokens and 2x output tokens",
    whatYouCanDo: "What you can do",
    whatYouCanDoDesc: "Alternative ways to spend your tokens",
    with200Scraping: "With 200 scraping tokens →",
    with1MAI: "With 1,000,000 AI tokens →",
    or: "Or",
    tokensPerPage: "@{tokens} tokens/page",
    tokensPerPost: "@{tokens} tokens/post",
    tokensPerReq: "~{tokens} tokens/req",
    googlePages: "Google Pages",
    linkedinPosts: "LinkedIn Posts",
    instagramPosts: "Instagram Posts",
    facebookPages: "Facebook Pages",
    smallContext: "Short context",
    mediumContext: "Medium context",
    largeContext: "Large context",
    topUpTitle: "💵 Top Up",
    topUpDescCrypto: "Pay with crypto to get a 20% bonus",
    topUpDescCard: "Credit / debit card",
    amountLabel: "Amount ($)",
    topUpBtn: "Top Up ${amount}",
    processing: "Processing...",
    continueBtn: "Continue →",
    backBtn: "← Back",
    cancelBtn: "Cancel",
    confirmAmount: "Confirm amount",
    youPay: "YOU PAY",
    youGet: "YOU GET",
    equalsTo: "= {scraping} scraping tokens or {ai} AI tokens",
    cryptoBonus: "🎁 Pay with crypto → get ${amount} (+20%)",
    choosePaymentMethod: "Choose payment method",
    cardLabel: "Card",
    cardNotAvailable: "Not available yet",
    cryptoLabel: "Crypto",
    cryptoDesc: "BTC, ETH, USDT · 10-30 min",
    cryptoBonusBadge: "+20%",
    invoiceCreated: "✅ Invoice created!",
    clickToPay: "Click here to pay",
    minimumTopUpError: "Minimum top-up is ${min}. Your amount: ${amount}. Need ${diff} more.",
    cardNotWorkingError: "Card payments are not working yet. Please try with crypto (+20% bonus).",
    invalidAmount: "Please enter a valid amount",
    topUpFailed: "Failed to create intent",
    invoiceFailed: "Failed to create invoice",
    presetAmounts: [5, 20, 50, 100, 200],
    convertTitle: "🔄 Convert",
    convertDesc: "Convert balance to tokens or between tokens",
    fromLabel: "FROM",
    toLabel: "TO",
    balanceOption: "Balance (${balance})",
    scrapingOption: "Scraping ({tokens})",
    aiOption: "AI ({tokens})",
    scrapingTokensOption: "Scraping tokens",
    aiTokensOption: "AI tokens",
    convertBtn: "Convert",
    converting: "Converting...",
    confirmBtn: "Confirm",
    convertConfirmBalance: "Convert ${amount} → {tokens} {type} tokens?",
    convertConfirmTokens: "Convert {fromAmount} {fromType} → {toAmount} {toType}?",
    convertSuccess: "✅ Tokens converted successfully!",
    convertFailed: "Conversion failed",
    approxUsd: "≈ ${cost}",
    dollarPrefix: "$",
    bonus:'bonus'
  },

visualizationPage: {
  // Header
  visualization: "Visualization",
  browseResults: "Browse scraped results one by one",
  backToTasks: "Back to Tasks",
  
  // Configuration
  configuration: "Configuration",
  selectTaskAndOptions: "Select task and visualization options",
  task: "Task",
  selectTask: "-- Select task --",
  done: "done",
  type: "Type",
  standard: "Standard",
  ai: "AI",
  mode: "Mode",
  all: "All",
  random: "Random",
  randomCount: "Random Count",
  
  // AI Prompt
  aiPrompt: "AI Prompt",
  aiPromptPlaceholder: "Describe what you want AI to analyze...",
  howItWorks: "How it works",
  howItWorksDesc: "Write a prompt for AI. Click variables below to insert them — they will be replaced with actual data from each result.",
  setFilterKeywordDesc: "Set a Filter Keyword to check AI response and see PASSED or FAILED for each result.",
  availableVariables: "Available Variables (click to insert)",
  filterCheckKeyword: "Filter: Check AI response for keyword",
  filterCheckDesc: "If keyword found → PASSED, if not → FAILED",
  keywordPlaceholder: "Keyword to find (e.g. yes, no, approved)",
  firstLineOnly: "First line only",
  fullText: "Full text",
  
  // Subtype
  subtype: "Subtype",
  
  // Start button
  startVisualization: "Start Visualization",
  loading: "Loading...",
  
  // Navigation
  prev: "Prev",
  result: "Result",
  of: "of",
  loaded: "Loaded",
  allLoaded: "all loaded",
  end: "End",
  next: "Next",
  reachedEnd: "You've reached the end! All ",
  resultsLoaded: "results loaded",
  loadingNextBatch: "Loading next batch...",
  
  // Status
  status: "Status",
  openProfile: "Open profile",
  keyword: "Keyword",
  viaPost: "Via post",
  position: "Position",
  page: "Page",
  period: "Period",
  
  // AI Analysis
  aiAnalysis: "AI Analysis",
  passed: "PASSED",
  failed: "FAILED",
  cost: "Cost",
  remaining: "Remaining",
  waitingForAI: "Waiting for AI response...",
  retry: "Retry",
  
  // No results
  noResultsFound: "No results found",
  noResultsDesc: "This task has no scraped results yet.",
  
  // Navigation hint
  arrowKeysHint: "Use ← → arrow keys to navigate · Images preload in background",
  
  // Image
  failedToLoadImage: "Failed to load image",
  loadingImage: "Loading image...",
  
  // Errors
  fetchFailed: "Failed to fetch data",
  
  // Filter statuses (for filtering tasks)
  filterConfig: "Filter Config",
  regularFilterStatus: "Regular Filter Status",
  aiFilterStatus: "AI Filter Status",
  allStatus: "All",
  passedStatus: "✅ Passed",
  rejectedStatus: "❌ Rejected",
  noAIStatus: "No AI",
  aiNotEnabled: "AI filtering is not enabled for this task",
  
  // Filter result badges
  passedFilter: "✅ Passed Filter",
  rejectedFilter: "❌ Rejected by Filter",
  aiPassedFilter: "🤖 AI Passed",
  aiRejectedFilter: "🤖 AI Rejected",
  noAIFilter: "🤖 No AI Filter",
  aiFilterResponse: "🤖 AI Filter Response",
  
  // Scraping status filter
  resultStatus: "Result Status",
  success: "Success",
  failedStatus: "Failed",
  
  // Open URL
  openURL: "Open URL ↗",
  
  // Raw data
  copyRaw: "Copy Raw",
  
  // Default filter pass word
  defaultPassWord: "yes",

  dataSource: "Data Source",
  scrapingData:  "Scraping",
  filteringData: "Filtering",
},


taskSelectionPage : {

  levelGoal: 'Goal',
  levelForWhom: 'For whom',
  levelNiche: 'Niche',
  levelSetup: 'Setup',
  newTaskTitle: 'Create Task',
  taskSelectionDesc: "Start from scratch or pick a ready-made template",
  fromScratch: "From scratch",
  fromScratchDesc: "Configure manually",
  fromTemplate: "From template",
  fromTemplateDesc: "Pick a preset",
  templatesLabel: 'Templates',
  cancel: "Cancel",
  continue: "Continue",
  useTemplate: "Use template",

  orUseGeneralTemplate: "Or use the general template for",
  coversBasics: "Covers the basics without extra configuration",
  orUseGeneralTemplate: "Use general template",

  backButton: "Back"
},

createTaskPage: {
    taskType: "Task Type",
  newTaskTitle: "New Task",
  tasksDesc: "Manage your scraping and filtering tasks",
  clearAll: "Clear All",
  taskName: "Task name",
  taskNamePlaceholder: "e.g. Find designers in Berlin",

   scrapingLabel: "Scraping",
  filteringLabel: "Filtering",
  scrapingFilteringLabel: "Scraping + Filtering",
  scrapingDesc: "Collect info from social media",
  filteringDesc: "Filter collected info",
  scrapingFilteringDesc: "Collect & Filter",
  
    scraping: {
      // Platform selection
      reels: "Reels",
      findInstagramReels: "Find Instagram Reels videos",

      platform: "Platform",
      step1ChooseNetwork: "Step 1: Choose social network",
      step2WhatToFind: "Step 2: What to find on {platform}?",
      
      // Subtypes
      posts: "Posts",
      pages: "Pages",
      findInstagramPosts: "Find Instagram posts & reels",
      findInstagramProfiles: "Find Instagram profiles & bios",
      findFacebookPosts: "Find public Facebook posts",
      findFacebookPages: "Find Facebook business pages & communities",
      findLinkedInPosts: "Find professional LinkedIn posts",
      
      // Author pages toggle
      scrapeAuthorPages: "Scrape Author Pages",
      scrapeAuthorPagesDesc: "Visit author profiles of found posts to extract bio, followers & contact info.",
      on: "ON",
      off: "OFF",
      
      // Who to find
      whoToFind: "Who do you want to find?",
      whoToFindPlaceholder: "Describe who or what you're looking for...",
      
      // AI Prompt
      aiPromptLabel: "AI Prompt for generating search queries",
      generateWithAI: "Generate with AI",
      generating: "Generating...",
      
      // Default prompt when no platform selected
      defaultPrompt: 'Write 30 relevant keywords or search phrases for finding "{target}" on social media. Write only resulted rows on new lines. Do not use numbers, bullet points, or markdown.',
      
      // Default prompts per platform
      // AI Prompt
      aiPromptLabel: "AI Prompt for generating search queries",
      generateWithAI: "Generate with AI",
      generating: "Generating...",
      resetPrompt: "Reset to default",

      // Default prompt when no platform selected
      defaultPrompt: 'Write 30 relevant keywords or search phrases for finding "{target}" on social media. Write only resulted rows on new lines. Do not use numbers, bullet points, or markdown.',

      // Default prompts per platform
      defaultPrompts: {
        instagram_posts: 'What words might appear in Instagram posts and reels related to "{target}". Write 30 relevant keywords or short phrases. Write only resulted rows on new lines. Do not use numbers, bullet points, or markdown.',
        instagram_pages: 'What words might appear in posts and biography of a person on Instagram who corresponds to the concept "{target}". Write 30 relevant keywords or short phrases. Write only resulted rows on new lines. Do not use numbers, bullet points, or markdown.',
        facebook_posts: 'What words might appear in public Facebook posts of a person or page related to the concept "{target}". Write 30 relevant keywords or short phrases. Write only resulted rows on new lines. Do not use numbers, bullet points, or markdown.',
        facebook_pages: 'What words might appear in the name, description, and posts of a Facebook page related to the concept "{target}". Write 30 relevant keywords or short phrases. Write only resulted rows on new lines. Do not use numbers, bullet points, or markdown.',
        linkedin_posts: 'What words might appear in LinkedIn posts and profile of a professional related to the concept "{target}". Write 30 relevant keywords or short phrases (job titles, skills, industries). Write only resulted rows on new lines. Do not use numbers, bullet points, or markdown.',
      },
      
// Required/optional badges
required: "Required",
optional: "Optional",

// AI Prompt sync states
autoSync: "Auto-sync",
manualMode: "Manual mode",
resetPrompt: "Reset to default",

      // Search queries
      searchQueries: "Search Queries",
      oneQueryPerLine: "One query per line.",
      addedAutomatically: "added automatically",
      clickToCheckGoogle: "Click 🔗 to check in Google.",
      enterSearchQueries: "Enter search queries...\none per line",
      google: "Google",
      activeQuery: "active query",
      activeQueries: "active queries",
      
      // Advanced settings
      advancedSettings: "Advanced Settings",
      searchLanguage: "Search Language",
      popular: "Popular",
      allLanguages: "All Languages",
      scrapingPeriod: "Scraping Period",
      anyTimeSelected: "Any time selected",
      periodsSelected: "Selected periods:",
      maxPagesPerQuery: "Max Pages per Query",
      
      // Period options
      anyTime: "Any Time",
      pastYear: "Past Year",
      pastMonth: "Past Month",
      pastWeek: "Past Week",
      past24h: "Past 24h",
      pastHour: "Past Hour",
      
      // Schedule
      schedule: "Schedule",
      oneTime: "One-time",
      runsOnce: "Runs once",
      repeat: "Repeat",
      autoRuns: "Auto-runs",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      every: "Every...",
      
      // Credits breakdown
      queries: "queries",
      pages: "Pages",
      periods: "periods",
      filtering: "Filtering",
      authorPages: "Author Pages",
      
      // Help tooltips
      clickOutsideToClose: "Click outside or Esc to close",
      
      // Help content
      help: {
        whoToFind: {
          title: "How to describe your target?",
          tips: [
            "Be specific: job title, industry, location",
            "Example: 'Marketing managers in London'",
            "Example: 'Software engineers at Google'",
            "Use natural language — we'll generate queries"
          ],
          links: [
            { text: "📖 Search Query Guide", url: "#" },
            { text: "🎯 Targeting Best Practices", url: "#" }
          ]
        },
        aiPrompt: {
          title: "AI Prompt Tips",
          tips: [
            "Write instructions for AI to generate search queries",
            "Use {target} — it will be replaced with your target description",
            "Be specific: ask for keywords, phrases, variations",
            "AI will return one query per line"
          ],
          links: []
        },
        keywords: {
          title: "Search Queries Tips",
          tips: [
            "One query per line = 1 credit per page",
            "Use quotes for exact phrases: 'marketing manager'",
            "site: filter added automatically",
            "Click 🔗 to preview in Google"
          ],
          links: [
            { text: "📖 Advanced Search Operators", url: "#" }
          ]
        },
        platform: {
          title: "Platform Guide",
          tips: [
            "Step 1: Choose social network",
            "Step 2: Select what to find (Pages or Posts)",
            "Instagram Pages: Find profiles, get bio & contact info",
            "Facebook Pages: Business pages & communities",
            "Facebook Posts: Public posts & content",
            "LinkedIn Posts: Professional content"
          ],
          links: [
            { text: "📖 Platform Tips", url: "#" }
          ]
        },
        instagramPagesInfo: {
          title: "Scrape Author Pages",
          tips: [
            "When enabled: If we find a post/reel, we'll visit the author's profile page",
            "Extracts: bio, follower count, contact info, external links",
            "Useful for: influencer research, lead generation, competitor analysis",
            "⚠️ Uses additional credits per author page visited"
          ],
          links: []
        },
        scrapingPeriod: {
          title: "Time Range",
          tips: [
            "Select multiple ranges",
            "Any Time = no restrictions",
            "More ranges = more credits"
          ],
          links: []
        },
        schedule: {
          title: "Schedule",
          tips: [
            "One-time: runs once",
            "Repeat: auto-runs at intervals"
          ],
          links: [
            { text: "📖 Automation Guide", url: "#" }
          ]
        }
      },
      
      // Actions
      createTask: "Create Task",
      creating: "Creating...",
      cancel: "Cancel",
      estimatedTokens: "⚡ Estimated tokens (approximately)"
    },
  
    filtering: {
      missingPlaceholdersError: "AI prompt must contain at least one placeholder. Available: {missing}",
missingPlaceholdersWarning: "Add at least one placeholder:",

      reelsMetrics: "Reels Metrics & Engagement",
  minViews: "Min Views",
  maxViews: "Max Views",
  minViewsPlaceholder: "0",
  maxViewsPlaceholder: "No limit",
  minLikes: "Min Likes",
  maxLikes: "Max Likes",
  minLikesPlaceholder: "0",
  maxLikesPlaceholder: "No limit",
  minComments: "Min Comments",
  maxComments: "Max Comments",
  minCommentsPlaceholder: "0",
  maxCommentsPlaceholder: "No limit",
  minEngagementRate: "Min Engagement Rate (%)",
  maxEngagementRate: "Max Engagement Rate (%)",
  minEngagementRatePlaceholder: "0",
  maxEngagementRatePlaceholder: "No limit",
  engagementFormula: "Engagement Formula",
  standardFormula: "Standard: likes/views + (comments×2)/views",
  simpleFormula: "Simple: likes/views",
  sortBy: "Sort Results By",
  byEngagement: "Engagement Rate",
  byLikes: "Likes Count",
  byComments: "Comments Count",
  topReelsCount: "Number of Top Reels to Select",
  topReelsCountPlaceholder: "30",
  generateSummary: "Generate AI Summary of Top Reels",
  generateSummaryDesc: "An AI-powered summary will be created analyzing patterns, trends, and insights from the selected reels",


  // Task selection
  selectTaskToFilter: "Select Task to Filter",
  chooseExistingTask: "Choose an existing scraping task for filtering",
  selectTask: "— Select a task —",
  task: "Task",
  loadingTasks: "Loading tasks...",
  failedToLoadTasks: "Failed to load tasks.",
  done: "done",
  filteringResultsFrom: "Filtering results from task",

  // Filter builder
  filterBuilder: "Filter Builder",
  filterBuilderDesc: "Set conditions to include or exclude results",
  allConditions: "All conditions",
  anyCondition: "Any condition",
  allConditionsDesc: "All conditions must match for a result to pass",
  anyConditionDesc: "At least one condition must match for a result to pass",
  addRule: "Add Rule",
  clearAllRules: "Clear All Rules",

  // AI filtering
  aiFiltering: "AI Filtering",
  enable: "Enable",
  availablePlaceholders: "Available Placeholders",
  aiPrompt: "AI Prompt",
  aiPromptPlaceholder: "Describe what kind of results should pass the filter...",
  testPrompt: "Test Prompt",
  matchCondition: "Match Condition",
  matchConditionDesc: "The AI response must contain this word/phrase to pass",
  wordToMatchPlaceholder: "e.g. yes",
  entireText: "Entire text",
  firstLineOnly: "First line only",

  // Validation errors
  selectTaskFirst: "Please select a task first",
  enterTaskName: "Please enter a task name",
  enterAiPrompt: "Enter AI prompt",
  configureScrapingFirst: "Please configure scraping first",
  enterSearchQueries: "Please enter search queries",
  selectPlatform: "Please select platform",
  unknownError: "Unknown error",

  // Task name defaults
  scrapingFilteringTaskDefault: "Scraping + Filtering Task",
  filterPrefix: "Filter",
  taskPrefix: "Task",

  // Credits
  estimatedTokens: "Estimated tokens (approximately)",

  // Buttons
  creating: "Creating...",
  createScrapingFilteringTask: "Create Scraping + Filtering Task",
  createTask: "Create Task",
  cancel: "Cancel",
},



  // en.js
instagram_reels: {
  // Prompts
  promptPart1FilterOnly: "Analyze this Instagram Reel.\n\nRespond in this exact format:\nLine 1: 'yes' or 'no'\n\n",
  promptPart1DescOnly: "Watch this Instagram Reel video and provide a detailed description of what happens.\n\nDescribe:\n- Visual content (scenes, objects, people)\n- Actions and activities\n- Text visible in the video\n- Audio/music (if identifiable)\n- Overall mood and style\n\nProvide a comprehensive description in 3-5 sentences.\n\n",
  promptPart1FilterAndDesc: "Analyze this Instagram Reel.\n\nRespond in this exact format:\nLine 1: 'yes' or 'no'\nLine 2+: Detailed description of what happens in the reel\n\n",
  promptPart3PassCondition: 'IMPORTANT: Result passes ONLY if response contains "{word}"',

  // Step 1: Metrics
  step1MetricsFilter: "Step 1: Metrics Filter",
  metricsFilterDesc: "Filter reels by views, likes, comments and engagement rate",
  minViews: "Min Views",
  maxViews: "Max Views",
  minLikes: "Min Likes",
  maxLikes: "Max Likes",
  minComments: "Min Comments",
  maxComments: "Max Comments",

  // Step 2: AI Filtering
  step2AiFiltering: "Step 2: AI Filtering",
  aiFilteringDesc: "AI will classify each reel based on your criteria",
  filterMethods: "Filter Methods",
  filterMethodsDesc: "Select one or more methods for AI to analyze the reels. You can combine multiple methods.",
  selectAtLeastOneMethod: "⚠️ Select at least one filter method above",
  yourPrompt: "Your Filter Prompt",
  aiPromptPlaceholder: "What should the AI check?",
  availablePlaceholders: "Available Placeholders for Selected Methods",
  matchCondition: "Pass Condition",
  matchConditionDesc: "Reel passes filter if AI response contains this word",
  wordToMatchPlaceholder: "e.g. yes",
  filterPromptPreview: "Filter Prompt Preview",

  // Step 3: Sorting
  step3Sorting: "Step 3: Sorting & Selection",
  sortingDesc: "Select top reels based on engagement",
  engagementFormula: "Engagement Formula",
  standardFormula: "Standard",
  simpleFormula: "Simple",
  standardFormulaDesc: "likes/views + (comments × 2)/views",
  simpleFormulaDesc: "likes/views",
  sortBy: "Sort By",
  byEngagement: "Engagement",
  byLikes: "Likes",
  byComments: "Comments",
  topReelsCount: "Top Reels Count",

  // Step 4: Generate Description
  step4GenerateDescription: "Step 4: Generate Description",
  generateDescriptionDesc: "AI will watch each reel and generate a detailed description of its content",
  descriptionAppliedToTop: "📌 Descriptions will be generated only for the top {count} reels (based on sorting settings in Step 3).",
  videoAnalysisCost: "Video Analysis Cost",
  videoAnalysisCostDesc: "The AI will watch the actual video content of each reel.\n\nCost: ~{tokens} tokens per minute of video.\nFor an average 30-second reel: ~{estimated} tokens.\nTotal for {count} top reels: ~{total} tokens.",
  descriptionHowItWorks: "The AI will analyze the actual video content (visual frames, scenes, objects, actions, text in video) and generate a detailed text description of what happens in the reel.",
  descPromptPreview: "Description Prompt Preview",
  descriptionForSummary: "Generated descriptions will be used as input for the AI Summary in Step 5.",

  // Step 5: Summary
  step5Summary: "Step 5: AI Summary",
  summaryDesc: "Generate AI summary of top performing reels",
  needDescriptionWarning: "⚠️ Enable description generation in Step 4 first",
  summaryDataFlow: "Summary receives descriptions + engagement metrics for each top reel",
  summaryPrompt: "Summary Prompt",
  summaryPromptPlaceholder: "Customize how the AI should summarize...",
  defaultSummaryPrompt: "Analyze these top-performing Reels and create a comprehensive summary.\n\nFor each reel, consider:\n- Content description\n- Engagement metrics (views, likes, comments)\n- Engagement rate\n- Key patterns and trends\n\nProvide:\n1. Overall trends across all reels\n2. Common characteristics of top performers\n3. Recommendations for content strategy",

  // Credits
  scrapingCost: "Scraping",
  aiCost: "AI Tokens",
  queries: "queries",
  pages: "pages",
  reels: "reels",
  tokens: "tokens",

  step4GenerateDescription: "Step 4: Generate Description",
  generateDescriptionDesc: "AI will watch each reel and generate a detailed description of its content",
  descriptionAppliedToTop: "📌 Descriptions will be generated only for the top {count} reels (based on sorting settings in Step 3).",
  videoAnalysisCost: "Video Analysis Cost",
  videoAnalysisCostDesc: "Cost: ~{tokens} tokens per minute of video.\nFor an average 30-second reel: ~{estimated} tokens.\nTotal for {count} top reels: ~{total} tokens.",
  descriptionHowItWorks: "The AI will analyze the actual video content (visual frames, scenes, objects, actions, text in video) and generate a detailed text description of what happens in the reel.",
  descPromptPreview: "Description Prompt Preview",
  
  // Step 5
  step5Summary: "Step 5: AI Summary",
  summaryDesc: "Generate AI summary of top performing reels",
  needDescriptionWarning: "⚠️ Enable description generation in Step 4 first",
  summaryDataFlow: "Summary receives descriptions + engagement metrics for each top reel",
  summaryPrompt: "Summary Prompt",
  summaryPromptPlaceholder: "Customize how the AI should summarize...",
  defaultSummaryPrompt: "Analyze these top-performing Reels and create a comprehensive summary.\n\nFor each reel, consider:\n- Content description\n- Engagement metrics (views, likes, comments)\n- Engagement rate\n- Key patterns and trends\n\nProvide:\n1. Overall trends across all reels\n2. Common characteristics of top performers\n3. Recommendations for content strategy",
},

},


visualizationTemplate: {
   keyword: "Keyword",
  instagramPost: "Instagram Post",//+
  instagramPage: "Instagram Page",//+
  facebookPost: "Facebook Post",//+
  facebookPage: "Facebook Page",//+
  linkedinPost: "LinkedIn Post",//+
  result: "Result", //+
  username: "Username", //+
  caption: "Caption",//+
  bio: "Bio",//+
  followers: "Followers",//+//+
  following: "Following",//+
  posts: "Posts",//+
  likes: "Number of likes", //+
  comments: "Number of comments",//+
  shares: "Shares",//+
  content: "Content", //+
  headline: "Headline",//+
  description: "Description",//+
  category: "Category",//+
  email: "Email",//+
  phone: "Phone",//+
  website: "Website",//+
  address: "Address",//+
  name: "Name",//+
  url: "URL",
  imageUrl: "Image URL",
  postUrl: "Post URL", //+
  pageUrl: "Page URL", //+
  postCode: "Post Code",
  scrapedUrl: "Scraped URL",
  scrapedAt: "Scraped At",
  foundViaUrl: "Found via URL",
  searchPosition: "Search Position",
  viaPost: "Via Post",
  status: "Status",
  date: "Date",//+
  noDescription: "No description",//+
  postImage: "Post Image", //+
  postContent: "Post Content",//+
  postInfo: "Post Info", //+
  engagement: "Engagement", //+
  author: "Author", //+
  foundVia: "Found via", //+
  profile: "Profile", //+
  pageStats: "Page Stats", //+
  details: "Details", //+
  contactInfo: "Contact Info",//+
  published: "Published",//+
  rawData: "Raw Data",//+
  rawJson: "Raw JSON",//+
  scraped: "Scraped", //+
  hasPhone: "Page has phone?",
hasEmail: "Page has email?",

usernameInstagramPost: "Owner username",
textInstagramPost: "Instagram post text",

instagram_profile_username: "Profile username",
instagram_profile_bio: "Profile bio",
instagram_profile_followers: "Number of followers",
instagram_profile_following: "Number of following",
instagram_profile_posts: "Number of posts",
instagram_profile_fullname: 'Full name',

facebook_post_text: "Post text",
facebook_page_name: "Page name",
facebook_page_description: "Page description",

linkedin_post_author: "Post author name",
linkedin_post_headline: "Post headline",
linkedin_post_content: "Post text",
linkedin_post_shares: "Number of shares",

  },



  // Add these to your en.js file under tasksListPage:

tasksListPage: {
  // Existing translations...
  myTasks: "My Tasks",
  active: "active",
  total: "total",
  running: "running",
  complete: "complete",
  newTask: "New Task",
  delete: "Delete",
  deleteConfirm: "Are you sure you want to delete this task?",
  edit: "Edit",
  createFilter: "Create Filter",
  export: {
    title: "Export Results",
    format: "Format",
    options: "Options",
    pretty: "Pretty JSON",
    prettyDesc: "Formatted for easy reading",
    dataType: "Data Type",
    filteringData: "Filtering Results",
    parseData: "Parse Results",
    statusFilter: "Status Filter",
    successOnly: "Success Only",
    allResults: "All Results",
    jsonDesc: "Full data with all information",
    urlsDesc: "Only URLs in text file",
    csvDesc: "Table format for Excel",
    cancel: "Cancel",
    export: "Export",
    exporting: "Exporting...",
    exportResults: "Export Results",
    notAuthenticated: "Not authenticated",
  },
  keywordStats: {
  title: "Keyword Statistics",
  subtitle: "Statistics of passed filters by keywords",
  keyword: "Keyword",
  searchPeriod: "Search Period",
  lastPage: "Last Page",
  passed: "Passed",
  noStats: "No statistics available",
  noStatsDesc: "Statistics will appear when filtering is complete",
},

  rename: {
      label:'Rename',
      cancel: "Cancel",
      saving: "Saving...",
      save: "Save",
      renamePlaceholder: "Task name",
      renameTaskDesc: "Enter a new name for this task",

      renameTask: "Rename Task"

  },
  duplicate: "Duplicate",
  createFilteringTask: "Create Filtering Task",
  moreActions: "More actions",
  start: "Start",
  stop: "Stop",
  visualization: "Visualization",
  checkResults: "Check Results",
  results: "Results",
  noReports: "No reports yet",
  reportsWillAppear: "Reports will appear here once they are generated",
  resultsTitle: "Results & Reports",
  openReport: "Open",
  untitled: "Untitled",
  unknown: "Unknown",
  filtering: "Filtering",
  scraping: "Scraping",
  scrapingAndFiltering: "Scraping + Filtering",
  authorPagesLabel: "Author Pages",
  links: "links",
  items: "items",
  jobsCompleted: "jobs completed",
  failed: "Failed",
  filteringConfig: "Filtering Configuration",
  aiFilteringEnabled: "AI Filtering Enabled",
  aiFilteringDisabled: "AI Filtering Disabled",
  passKeyword: "Pass Keyword",
  checkFirstRowOnly: "Check First Row Only",
  allRules: "All rules must match",
  anyRule: "Any rule can match",
  filterRules: "Filter Rules",
  aiPrompt: "AI Prompt",
  filteringResults: "Filtering Results",
  totalRuns: "Total Runs",
  doneFilter: "Done",
  runningFilter: "Running",
  pendingFilter: "Pending",
  passedFilter: "Passed",
  rejectedFilter: "Rejected",
  failedFilter: "Failed",
  ofTotal: "of total",
  aiResults: "AI Results",
  aiPassed: "AI Passed",
  aiRejected: "AI Rejected",
  scrapingStats: "Scraping Statistics",
  googleJobs: "Google Jobs",
  scrapedLinks: "Scraped Links",
  found: "Found",
  stage: "Stage",
  completed: "Completed",
  keywords: "Keywords",
  searchConfig: "Search Configuration",
  maxPages: "Max pages",
  additionalSettings: "Additional Settings",
  scrapeAuthorPages: "Scrape Author Pages",
  enabled: "Enabled",
  disabled: "Disabled",
  authorPagesEnabledDesc: "If we get a link to post/reel in Google, we will get info of the author",
  authorPagesDisabledDesc: "If we get a link to post/reel in Google, we will not check them",
  created: "Created",
  started: "Started",
  updated: "Updated",
  finished: "Finished",
  failedToLoadTasks: "Failed to load tasks",
  retry: "Retry",
  notAuthenticated: "Not authenticated",
  fetchFailed: "Failed to fetch tasks",
  queueNotice: "Tasks are processed in queue.",
  topUpBalance: "Top up balance",
  fasterProcessing: "for faster processing. You'll receive an email once the task is complete.",
  showAll: "Show all",
  showLess: "Show less",
  more: "more",
  valuesCount: "values",
  containsAny: "Contains any",
  containsAnyOf: "Contains any of",
  excludesAll: "Excludes all",
  excludesAllOf: "Excludes all of",
  isNotEmpty: "Is not empty",
  isTrue: "Is true",
  isFalse: "Is false",
  equals: "Equals",
  contains: "Contains",
  doesNotContain: "Does not contain",
  greaterThan: "Greater than {{val}}",
  lessThan: "Less than {{val}}",
  between: "Between {{min}} and {{max}}",
  noAITokens: "No AI Tokens",
  noScrapingTokens: "No Scraping Tokens",
  noAITokensTitle: "AI tokens depleted",
  noScrapingTokensTitle: "Scraping tokens depleted",
  topUp: "Top Up",
  paused: "Paused",
  
  // Reels Configuration
  reelsConfig: "Reels Configuration",
  sortBy: "Sort by",
  topReels: "Top",
  engagementFormula: "Formula",
  metricsFiltering: "Metrics Filtering",
  aiSummary: "AI Summary",
  metricsFilter: "Metrics Filters",
  minViews: "Min Views",
  maxViews: "Max Views",
  minLikes: "Min Likes",
  maxLikes: "Max Likes",
  minComments: "Min Comments",
  maxComments: "Max Comments",
  minEngagement: "Min Engagement",
  maxEngagement: "Max Engagement",
  filteringPrompt: "AI Filtering Prompt",
  summaryPrompt: "AI Summary Prompt",
  
  // Status labels
  done: "Done",
  completed: "Completed",
  pending: "Pending",
  
  // Time
  justNow: "Just now",
  minutesAgo: "{{count}} min ago",
  hoursAgo: "{{count}}h ago",
  daysAgo: "{{count}}d ago",
  
  // Periods
  periodHour: "Hour",
  periodDay: "Day",
  periodWeek: "Week",
  periodMonth: "Month",
  periodYear: "Year",
  periodAny: "Any time",
  
  // Platforms
  instagramPages: "Instagram Pages",
  instagramPosts: "Instagram Posts",
  instagramReels: "Instagram Reels",
  facebookPosts: "Facebook Posts",
  facebookPages: "Facebook Pages",
  linkedinPosts: "LinkedIn Posts",
}

};